export default (state={}, action) => {
  switch(action.type) {
    case 'RETRIEVE_POST':
      state = { isLoading: true  }
      break;
    case 'RETRIEVE_RECOMMENDED_POSTS':
      state = { isLoading: true  }
      break;
    case 'RETRIEVE_CATEGORY_POSTS':
      state = { isLoading: true  }
      break;
    case 'RETRIEVE_ALL_POSTS':
      state = { isLoading: true  }
      break;
    case 'RETRIEVE_MEMBER_NEWS':
      state = { isLoading: true  }
      break;
    case 'RETRIEVE_RECIPES':
      state = { isLoading: true  }
      break;
    case 'RETRIEVE_SEARCH':
      state = { isLoading: true  }
      break;
    case 'RETRIEVE_RECIPE_POST':
      state = { isLoading: true  }
      break;
    case 'RETRIEVE_RECIPES_NEXT_PAGE':
      state = { ...state }
      break;
    case 'RETRIEVE_BLOG_NEXT_PAGE':
      state = { ...state }
      break;
    case 'RETRIEVE_RECIPE_CATEGORY_POSTS':
      state = { isLoading: true  }
      break;
    case 'RETRIEVE_RECIPE_CATEGORY_POSTS_FULFILLED':
      state = {
        recipesPopularPosts: action.payload.popularPosts,
        recipesCategoryPosts: action.payload.recipesCategoryPosts,
        isLoading: false,
      }
      break;
    case 'RETRIEVE_RECIPE_POST_FULFILLED':
      state = {
        recipesPopularPosts: action.payload.popularPosts,
        recipePost: action.payload.recipePost,
        recipePostContent: action.payload.recipePostContent,
        recommendedPosts: action.payload.recommendedPosts,
        isLoading: false,
      }
      break;
    case 'RETRIEVE_RECOMMENDED_POSTS_FULFILLED':
      state = { ...state,
        recommendedPosts: action.payload,
      }
      break;
    case 'RETRIEVE_SEARCH_FULFILLED':
      state = { ...state,
        search_results: action.payload.search_results,
        isLoading: false,
      }
      break;
    case 'RETRIEVE_RECIPES_FULFILLED':
      state = { ...state,
        recipesPopularPosts: action.payload.popularPosts,
        recipes: action.payload.recipes,
        isLoading: false,
      }
      break;
    case 'RETRIEVE_CATEGORY_POSTS_FULFILLED':
      state = { ...state,
        categoryPosts: action.payload.categoryPosts,
        featuredPost: action.payload.featuredPost,
        popularPosts: action.payload.popularPosts,
        subHeader: action.payload.subHeader,
        isLoading: false,
      }
      break;
    case 'RETRIEVE_FEATURED_POSTS_FULFILLED':
      state = { ...state,
        featuredPosts: action.payload,
      }
      break;
    case 'RETRIEVE_ALL_POSTS_FULFILLED':
      state = { ...state,
        allPosts: action.payload.allPosts,
        popularPosts: action.payload.popularPosts,
        isLoading: false,
      }
      break;
    case 'RETRIEVE_BLOG_NEXT_PAGE_FULFILLED':
      state = { ...state,
        blogNextPage: action.payload.blogNextPage,
      }
      break;
    case 'RETRIEVE_RECIPES_NEXT_PAGE_FULFILLED':
      state = { ...state,
        recipesNextPage: action.payload.recipesNextPage,
      }
      break;
    case 'RETRIEVE_POST_AND_AUTHOR_FULFILLED':
      state = { ...state,
        authorInfo: action.payload.authorInfo,
        authorThumbnail: action.payload.authorThumbnail,
        popularPosts: action.payload.popularPosts,
        recommendedPosts: action.payload.recommendedPosts,
        post: action.payload.post,
        isLoading: false,
      }
      break;
    case 'RETRIEVE_MEMBER_NEWS_FULFILLED':
      state = {...state,
        isLoading: false,
        memberNews: action.payload,
      }
      break;
    default: // Do nothing
  }

  return state;
};
